const parseSalaryLabel = (salaryLabel: string): string => {
  const num = Number(salaryLabel);
  if (isNaN(num)) {
    return salaryLabel;
  }

  if (num < 100) {
    return `$${num}`;
  }

  if (num >= 1000) {
    return `$${Math.round(num / 1000)}K`;
  }

  return `$${num}`;
};

export const getFacetLabelText = (
  label?: string | { lang: string; text: string },
  facetKey?: string,
): string => {
  if (typeof label === 'string') {
    return facetKey === 'salaryMin' ? parseSalaryLabel(label) : label;
  } else if (typeof label === 'object' && typeof label?.text === 'string') {
    return label.text;
  }
  return '';
};
